<template>
    <LayoutDefault
        variant="white"
    >
        <TransitionFadeOut>
            <AtomFullPageLoader variant="black" v-if="loaders['GET_HOME_EVENTS']" />
        </TransitionFadeOut>
        <OrganismHomeHero />
        <OrganismHomeAbout />
        <AtomSectionSeparator />
        <OrganismHomeAnarchive />
        <OrganismHomeEvents />
    </LayoutDefault>
</template>

<script>
import LayoutDefault from "../layouts/LayoutDefault.vue";
import OrganismHomeHero from "../components/home/organisms/OrganismHomeHero.vue";
import OrganismHomeAbout from "../components/home/organisms/OrganismHomeAbout.vue";
import AtomSectionSeparator from "../components/global/atoms/AtomSectionSeparator.vue";
import OrganismHomeAnarchive from "../components/home/organisms/OrganismHomeAnarchive.vue";
import OrganismHomeEvents from "../components/home/organisms/OrganismHomeEvents.vue";
import AtomFullPageLoader from "../components/global/atoms/AtomFullPageLoader.vue";
import {mapActions, mapState} from "vuex";
import TransitionFadeOut from "../transitions/TransitionFadeOut.vue";
import ImageLoading from "../mixins/image-loading";

export default {
    name: 'PageHome',
    mixins: [ImageLoading],
    components: {
        TransitionFadeOut,
        AtomFullPageLoader,
        OrganismHomeEvents,
        OrganismHomeAnarchive, AtomSectionSeparator, OrganismHomeHero, OrganismHomeAbout, LayoutDefault},
    data() {
        return {
            isImagesLoading: true,
        }
    },
    computed: {
        ...mapState('ui', [
            'loaders'
        ]),
        isLoading() {
            return this.loaders['GET_HOME_EVENTS'] || this.isImagesLoading;
        }
    },
    mounted() {
        this.getHomeHeader();
        this.awaitImagesLoading().then(() => {
            this.isImagesLoading = false;
        })
    },
    methods: {
        ...mapActions('home', {
            getHomeHeader: 'getHomeHeaderSection'
        }),
    },
}
</script>

<style lang="scss"></style>
